var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('div',[_c('div',[_c('h3',{staticClass:"empty__title"},[_vm._v("Ocurrió un error al mostrar esta página.")]),_c('router-link',{staticClass:"empty__link",attrs:{"to":"/"}},[_vm._v("Volver a la página principal")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }